//libs
import { styled } from '@nykaa/ui-components';

//constants
import { BREAKPOINTS } from 'shared/styles/base';

//components
import ProductCard from 'shared/components/Product';
import BasePromotionText from 'shared/components/PromotionText';

export const Container = styled.div<{ maxWidth: number }>`
  margin-bottom: ${({ theme }) => theme.spacing.spacing80};
  width: calc(50% - 2px);
  display: flex;
  position: relative;
  justify-content: space-between;
  flex-direction: column;

  @media screen and (min-width: ${BREAKPOINTS.DESKTOP}px) {
    width: ${({ maxWidth }) => maxWidth}px;
    margin-right: ${({ theme }) => theme.spacing.spacing100};
    &:nth-child(4n) {
      margin-right: 0;
    }

    border: 1px solid ${({ theme }) => theme.colors.textDecorative};
    &:hover {
      box-shadow: ${({ theme }) => theme.elevations.shadow400};
    }
  }
`;

export const Product = styled(ProductCard)`
  & a:hover {
    box-shadow: none;
  }

  & .product__description {
    padding-left: ${({ theme }) => theme.spacing.spacing40};
    padding-right: ${({ theme }) => theme.spacing.spacing40};
  }
`;

export const PromotionTextDesktop = styled(BasePromotionText)`
  ${({ theme }) => theme.typography.bodySmall};
`;
